export default __webpack_public_path__ + "static/media/dumbbells.d9a903e8.jpeg";